module.exports = __webpack_public_path__ + "static/img/7.5d80308.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/7.png
// module id = 5ETb
// module chunks = 0